/* eslint-disable @typescript-eslint/ban-ts-comment */
import React from 'react'
import { Box, Grid } from '@mui/material'
import { EmtIcon, EmtTypography } from 'emt-components-v2'
import { Progress } from '../Progress'
import { ConnaissanceBox } from '../ConnaissanceBox'
import { LightBox } from '../../Profile/partials/StyledComponents'

interface BadgeIcon {
  '@type': string
  '@id': string
  type: string
  value: string
  color: string
}

interface BadgeLabel {
  '@type': string
  '@id': string
  label: string
  color: string
  icon: string
}

interface KnowledgeBadge {
  '@type': string
  '@id': string
  color: string
  description: string
  icon: BadgeIcon
  label: BadgeLabel
  plainWidth: boolean
}

interface ExperienceBadge {
  '@type': string
  '@id': string
  position: number
  icon: BadgeIcon
  description: string
  plainWidth: boolean
}

interface PetsitterExperience {
  '@type': string
  '@id': string
  knowledgeBadge: KnowledgeBadge
  experienceBadges: ExperienceBadge[]
  description: string
  title: string
}

type Props = {
  petsitterExperience: PetsitterExperience
}

export const Experience: React.FC<Props> = ({ petsitterExperience }) => {
  const { knowledgeBadge, experienceBadges, description, title } = petsitterExperience

  const infoBoxData = experienceBadges?.map((badge) => ({
    iconClass: badge.icon.type,
    text: badge.description,
  }))

  const rows: Array<Array<{ iconClass: string; text: string }>> = []
  for (let i = 0; i < infoBoxData?.length; i += 3) {
    rows.push(infoBoxData?.slice(i, i + 3))
  }

  const progressValue = Number(knowledgeBadge.icon.value)
  const progressColor = knowledgeBadge.icon.color

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '24px' }}>
      <EmtTypography variant="h4" fontWeight={800}>
        {title}
      </EmtTypography>
      <LightBox sx={{ minHeight: '0', padding: '16px', borderColor: '#B8C6F5', backgroundColor: '#E6ECFF80' }}>
        <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: '16px' }}>
          <Progress value={progressValue} color={progressColor} />
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: '4px', marginBottom: '4px', color: '#0030CC' }}>
              <EmtIcon className={knowledgeBadge?.label.icon} sx={{ fontWeight: 100, fontSize: '14px!important' }} />
              <EmtTypography variant="body1" fontWeight="700" fontSize="18px">
                Compétences certifiées
              </EmtTypography>
            </Box>
            <EmtTypography variant="body2">{knowledgeBadge?.description}</EmtTypography>
          </Box>
        </Box>
      </LightBox>
      <Grid container spacing={2}>
        {rows.map((row, rowIndex) => (
          <React.Fragment key={rowIndex}>
            {row.map((item, index) => (
              <Grid item xs={6} sm={6} md={row.length === 3 ? 4 : 6} key={index}>
                <ConnaissanceBox iconClass={item.iconClass} text={item.text} />
              </Grid>
            ))}
          </React.Fragment>
        ))}
      </Grid>
      <EmtTypography variant="body1">{description}</EmtTypography>
    </Box>
  )
}
